<template>
  <div>
    <span class="definition">{{`${data.definition}`}}</span><span class="dictionary-name">{{data.dictionaryName}}</span>
  </div>
</template>
<script>
export default {
  name: 'SmallResult',
  props: {
    data: Object,
  }
}
</script>

<style scoped>
.dictionary-name {
    margin-left:10px;
    color: #afafaf;
    font-size: 80%;
}
.definition {
    font-size:1.1rem;
}
</style>